<template>
  <f7-page>
    <b-container fluid class="main-content icon-homepage-button-request-payment">
      <b-row class="homepageTextBloc1">
        <b-col sm="12">
          <transition name="slide-fade-title" appear>
            <div class="d-block text-center">
              <!-- <img width="450px" height="22%" :src="MrBgLogo" alt="mr_logo_green" /> -->
              <img :src="imgVarsLong" width="400px" height="62px" alt="DealPrudence" class="largescreen" style="margin-top:0.2rem">
            </div>
          </transition>
        </b-col>
      </b-row>
      <transition name="slide-fade-title" appear>
        <b-row v-if="data" class="homepageCards offset-2 col-8">
          <carousel :items="nbMaxItem" class="col-12" center loop :nav="false" :dots="false" :autoplay="data.length > nbMaxItem">
            <b-col v-for="button in data" :key="button.id" v-if="hasRight(button.right)" cols="12" class="d-flex flex-row justify-content-center">
              <div class="homeCardBody text-center" :class="button.class"  @click="redirect(button.link)">
                <i :class="button.icon" style="font-size:50px"></i>
                <h4>{{ $t(button.title) }}</h4>
                <b-button v-if="button.actionTitle && !flagTOOLBOX" class="btn" size="lg">
                  {{ $t(button.actionTitle) }}
                </b-button>
              </div>
            </b-col>
          </carousel>
        </b-row>
      </transition>
    </b-container>
  </f7-page>
</template>

<script>
import carousel from 'vue-owl-carousel2'
import buttonsData from '@/pages/user/data/homepageData.json'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {loadPage} from '@/helpers/routing'
import DealPrudenceLogo from '../../assets/static/images/homepage/dealprudence_texte_seul.png'
import design from '@/design/design.json'
import conf from "@/config/config.dev";

export default {
  name: 'Homepage',
  components: {
    carousel
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  computed: {
    imgVarsLong () {
      return this.design.headbandLogoLong
    }
  },
  data () {
    return {
      data: [],
      backgroundImg: 'background-image: url(' + Img +')',
      flagTOOLBOX: conf.visual === 'TOOLBOX',
      design: design.menu,
      imgLogo: Logo,
      MrBgLogo: DealPrudenceLogo,
      nbButtons: 0,
      nbMaxItem: 3,
      nbMaxColor: 4,
     }
  },
  created () {
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (!item.disabled && !item.hidden && this.hasRight(item.right)) {
        that.getCardClass
        item.class = that.getCardClass(item) + ' ' + item.class
        availableButtons.push(item)
      }
    })
    console.log('buttonsData', buttonsData)
    console.log('availableButtons', availableButtons)
    this.data = availableButtons
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }
  },
  mounted () {
  },
  methods: {
    getCardClass (button) {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.firstOn().rights.rightIs(right, true)
    },
    redirect (url) {
      loadPage(this, { url: url })
    }
  }
}
</script>
<style scoped>
/* .card, .card-body .card-title {
  background: var(--actionButtonColorViolet);
  color: var(--actionTextColorWhite)!important;
  min-height: 300px;
} */

.homeCardBody {
  color: var(--actionTextColorWhite)!important;
  min-height: 250px;
  min-width: 250px;
  width: 250px;
  height: 250px;
  border-radius: var(--borderRadius);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content:space-around;
}

.homeCardBody h4{
  color: var(--actionTextColorWhite)!important;
}

.homeCardBody.homeCardBody-1 {
  background: linear-gradient(0.25turn,#11b1fd,#11b1fd);
}

.homeCardBody.homeCardBody-2 {
  background: linear-gradient(0.25turn,#00a76c,#00a76c)
}

.homeCardBody.homeCardBody-3 {
  background: linear-gradient(0.25turn,#ffac00,#ffac00)
}

.homeCardBody.homeCardBody-4 {
  background: linear-gradient(0.25turn,#6b6aea,#6b6aea)
}

.main-content {
  height: 100%;
  overflow-x: hidden;
}
.main-page-positionning {
  margin-top: 20px;
  margin-bottom: 20px;
}
.homepageBackgroundImage {
  background-size: cover;
}
.homepageBaseline {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageBaselineText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 1.2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageSubTitle {
  display: block !important;
  text-align: center;
  top: 10%;
}
.homepageSubTitleText {
  margin-top: 2%;
  font-weight: bolder;
  font-size: 2rem;
  line-height: normal;
  color: #ffffff;
}
.homepageTitle {
  display: block !important;
  text-align: center;
  top: 10%;
  height: 500px;
}
.homepageTitleText {
  margin-top: 2%;
  /* font-weight: bolder; */
  font-size: 3rem;
  line-height: normal;
  /* color: #ffffff; */
}

@media (min-width:630px) and (max-width:889px) {
  .homepageBaselineText {
    font-size: 1.5rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 4rem;
  }
}
@media (min-width:890px) and (max-width:991px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 5rem;
  }
}

@media (min-width:992px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 6rem;
  }
}

@media (min-width:1030px) and (max-width:1199px) {
  .homepageBaselineText {
    font-size: 2rem;
  }
  .homepageSubTitleText {
    font-size: 2rem;
  }
  .homepageTitleText {
    font-size: 7rem;
  }
}
@media (min-width:1200px) {
  .homepageBaselineText {
    font-size: 2.5rem;
  }
  .homepageSubTitleText {
    font-size: 2.5rem;
  }
  .homepageTitleText {
    font-size: 8rem;
  }
}

@media (min-width:992px) {
  .main-page-positionning {
    margin-top: 40px;
    margin-bottom: 40px;
  }
}

.homepageTextBloc1 {
  position: fixed;
  margin-top: -50px;
  top: calc(20% - 50px);
  width: 100%;
}

.homepageTextBloc2 {
  position: fixed;
  height: 200px;
  margin-top: -40px;
  top: 20%;
  width: 100%;
}

.homepageTextBloc3 {
  position: fixed;
  height: 200px;
  margin-top: -180px;
  top: calc(93% + 100px);
  width: 100%;
}

@media (max-width:991px) {
  .homepageTextBloc1 {
    /* top: calc(50% + 44px); */
  }
  .homepageTextBloc2 {
    top: calc(20% + 44px);
  }
  .homepageTextBloc3 {
    top: calc(80% + 44px);
  }
  .homepageTitle > img {
    width: 300px;
    height: 150px;
    object-fit: contain;
  }
  .main-content {
    height: calc(100% - 44px);
  }
}

.homepageSubTitleLogo {
  width: 200px;
  margin-right: 1rem;
}

@media (max-width:450px) {
  .homepageSubTitleLogo {
    width: 350px;
  }
}

/* .icon-homepage-button-request-payment {
  background-image: url('./../../assets/static/images/homepage/accueil.png');
} */
</style>
